"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ComponentContainer = require("../../../Framework/ComponentContainer");
var _BulkNames = _interopRequireDefault(require("../Components/BulkNames"));
var _find = _interopRequireDefault(require("lodash/find"));
var _sumBy = _interopRequireDefault(require("lodash/sumBy"));
var _flatten = _interopRequireDefault(require("lodash/flatten"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _excluded = ["BulkNamesComponent", "activeSizeVariant"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BulkNamesContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(BulkNamesContainer, _React$Component);
  var _super = _createSuper(BulkNamesContainer);
  function BulkNamesContainer() {
    var _this;
    _classCallCheck(this, BulkNamesContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "initialState", {
      textInputs: [{
        text: '',
        amount: 1
      }]
    });
    _defineProperty(_assertThisInitialized(_this), "state", _this.initialState);
    _defineProperty(_assertThisInitialized(_this), "totalAmount", function () {
      var textInputs = _this.state.textInputs;
      var filledBulkNameInputs = [];
      var _iterator = _createForOfIteratorHelper(textInputs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var input = _step.value;
          if (input.text !== '') {
            if (input.amount === 0) {
              input.amount = 1;
            }
            filledBulkNameInputs.push(input);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return (0, _sumBy["default"])(filledBulkNameInputs, 'amount');
    });
    _defineProperty(_assertThisInitialized(_this), "saveBulkNamesConfiguration", function () {
      var _this$props = _this.props,
        selectedVariant = _this$props.selectedVariant,
        activeSizeVariant = _this$props.activeSizeVariant,
        handleChange = _this$props.handleChange,
        handleSave = _this$props.handleSave,
        onClose = _this$props.onClose;
      var textInputs = _this.state.textInputs;
      var summedAmount = _this.totalAmount();
      handleChange(summedAmount);
      var reformattedTextInputs = (0, _flatten["default"])(textInputs.map(function (input) {
        var inputs = [];
        if (input.text !== '') {
          for (var i = 1; i <= input.amount; i++) {
            inputs.push(input.text);
          }
        }
        return inputs;
      }));
      if (selectedVariant.sizes.length > 0) {
        var sizeVariant = (0, _find["default"])(selectedVariant.sizes, {
          identifier: activeSizeVariant.identifier
        });
        handleSave(sizeVariant.identifier, reformattedTextInputs);
      } else {
        handleSave(selectedVariant.identifier, reformattedTextInputs);
      }
      onClose();
    });
    _defineProperty(_assertThisInitialized(_this), "handleText", function (text, i) {
      return function (e) {
        var textInputs = _toConsumableArray(_this.state.textInputs);
        if (text === 'text') {
          textInputs[i].text = e.target.value;
        } else {
          textInputs[i].amount = e;
        }
        _this.setState({
          textInputs: textInputs
        });
      };
    });
    _defineProperty(_assertThisInitialized(_this), "addTextField", function (e) {
      e.preventDefault();
      var textInputs = _this.state.textInputs.concat({
        text: '',
        amount: 1
      });
      _this.setState({
        textInputs: textInputs
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDelete", function (i) {
      return function (e) {
        e.preventDefault();
        var textInputs = [].concat(_toConsumableArray(_this.state.textInputs.slice(0, i)), _toConsumableArray(_this.state.textInputs.slice(i + 1)));
        _this.setState({
          textInputs: textInputs
        });
      };
    });
    return _this;
  }
  _createClass(BulkNamesContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        selectedVariant = _this$props2.selectedVariant,
        activeSizeVariant = _this$props2.activeSizeVariant;
      if (selectedVariant.sizes.length > 0) {
        var sizeVariant = (0, _find["default"])(selectedVariant.sizes, {
          identifier: activeSizeVariant.identifier
        });
        var bulkNamesSizes = sizeVariant.bulkNames;
        var bulkNamesInputs = Object.values(bulkNamesSizes.reduce(function (indexedNames, text) {
          var amount = (0, _get["default"])(indexedNames, "".concat(text, ".amount"), 0) + 1;
          indexedNames = _objectSpread(_objectSpread({}, indexedNames), {}, _defineProperty({}, text, {
            text: text,
            amount: amount
          }));
          return indexedNames;
        }, {}));
        if (bulkNamesSizes.length > 0) {
          this.setState({
            textInputs: bulkNamesInputs
          });
        }
      } else {
        var bulkNames = selectedVariant.bulkNames;
        var _bulkNamesInputs = Object.values(bulkNames.reduce(function (indexedNames, text) {
          var amount = (0, _get["default"])(indexedNames, "".concat(text, ".amount"), 0) + 1;
          indexedNames = _objectSpread(_objectSpread({}, indexedNames), {}, _defineProperty({}, text, {
            text: text,
            amount: amount
          }));
          return indexedNames;
        }, {}));
        if (bulkNames.length > 0) {
          this.setState({
            textInputs: _bulkNamesInputs
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var textInputs = this.state.textInputs;
      var _this$props3 = this.props,
        BulkNamesComponent = _this$props3.BulkNamesComponent,
        activeSizeVariant = _this$props3.activeSizeVariant,
        props = _objectWithoutProperties(_this$props3, _excluded);
      var size = !(0, _isEmpty["default"])(activeSizeVariant) && activeSizeVariant.size.split(' ').pop();
      return /*#__PURE__*/_react["default"].createElement(BulkNamesComponent, _extends({
        handleDelete: this.handleDelete,
        addTextField: this.addTextField,
        textInputs: textInputs,
        handleText: this.handleText,
        saveConfigurationBulkNames: function saveConfigurationBulkNames() {
          return _this2.saveBulkNamesConfiguration();
        },
        totalAmount: this.totalAmount,
        size: size,
        activeSizeVariant: activeSizeVariant
      }, props));
    }
  }]);
  return BulkNamesContainer;
}(_react["default"].Component);
var mapStateToProps = function mapStateToProps() {
  return {
    Component: BulkNamesContainer,
    BulkNamesComponent: _BulkNames["default"]
  };
};
var _default = exports["default"] = (0, _ComponentContainer.containerConnect)(mapStateToProps);